import BaseService from '@/service/modules/BaseService'
import BasePageableInfo from '@/model/modules/BasePageableInfo'
import axios from '@/axios'
import UserGroupTokenInfo from '@/model/modules/UserGroupTokenInfo'

export default class UserGroupTokenService extends BaseService {
  protected static baseUrl: string = '/groupSecret'

  public static list(example: { [index: string]: any }, pageNum: number, pageSize: number): Promise<BasePageableInfo<UserGroupTokenInfo>> {
    example.page = pageNum
    example.size = pageSize
    return new Promise<BasePageableInfo<UserGroupTokenInfo>>((resolve, reject) => {
      axios.get(this.baseUrl + '/group_secret-list', {
        params: example
      }).then(resp => {
        const result: BasePageableInfo<UserGroupTokenInfo> = new BasePageableInfo()
        result.count = resp.data.body.totalElements
        result.dataList = resp.data.body.content
        resolve(result)
      })
    })
  }
}
